<h2 *ngIf="headerMessage">
  <span>{{ headerMessage }}</span>
</h2>

<ng-container *ngIf="customMsgBox && showNoResultsMessageCondition;else table">
  <ng-content class="custom-search-results-advise">

  </ng-content>
</ng-container>
<ng-template #table>
<ng-container #table *ngIf="showCondition">
  <table [class]="'wa-table ' + getClasses(extraClass)">
    <thead [ngClass]="{'no-sort':!computeSortHeadersClass()}" class="wa-table__header-group">
      <tr
        app-headers-component
        [isSortableFunc]="isSortableFunc"
        [headers]="headers"
        (changeSort)="headerClickInner($event)"
        (subHeaderAction)="subHeaderClickInner($event)"
        class="wa-table__row"
      ></tr>
    </thead>
    <ng-container
      *ngIf="isDataLoading === true || data?.length > 0; else noresults"
    >
      <tbody
        *ngFor="let element of data; let i = index; trackBy :rowTrackBy"
        [class]="
          'wa-table__row-group ' +
          (customClassesForTBody == undefined
            ? ''
            : customClassesForTBody(element))
        "
      >
        <tr
          [class]="
            'wa-table__row ' +
            getClasses(row_group.extraClass) +
            ' ' +
            (customClassesForTr == undefined ? '' : customClassesForTr(element))
          "
          [routerLink]="getRouteForRow != undefined ? [getRouteForRow(element)?.route] : undefined"
          [queryParams]="getRouteForRow != undefined ? getRouteForRow(element)?.params : undefined"
          [queryParamsHandling]="getRouteForRow != undefined ? 'merge' : 'merge'"
          *ngIf="row_group"
        >
          <td [attr.colspan]="columns.length">
            <ng-container
              [ngTemplateOutlet]="row_group.template"
              [ngTemplateOutletContext]="{ $implicit: assignIndex(i, element) }"
            ></ng-container>
          </td>
        </tr>
        <tr
        [routerLink]="getRouteForRow != undefined ? [getRouteForRow(element)?.route] : undefined"
        [queryParams]="getRouteForRow != undefined ? getRouteForRow(element)?.params : undefined"
        [queryParamsHandling]="getRouteForRow != undefined ? 'merge' : 'merge'"
          [class]="
            'wa-table__row' +
            ' ' +
            (customClassesForTr == undefined ? '' : customClassesForTr(element))
          "
          [ngClass]="{
            'visibility--hide-mobile': columns_responsive.length > 0
          }"
        >
          <td
            *ngFor="let column of columns;"
            [class]="'wa-table__cell ' + getClasses(column.extraClass)"
          >
            <ng-container
              [ngTemplateOutlet]="column.template"
              [ngTemplateOutletContext]="{ $implicit: assignIndex(i, element) }"
            >
            </ng-container>
          </td>
        </tr>
        <tr
        [routerLink]="getRouteForRow != undefined ? [getRouteForRow(element)?.route] : undefined"
        [queryParams]="getRouteForRow != undefined ? getRouteForRow(element)?.params : undefined"
        [queryParamsHandling]="getRouteForRow != undefined ? 'merge' : 'merge'"
          [class]="
            'wa-table-simple visibility--hide-desktop' +
            ' ' +
            (customClassesForTr == undefined ? '' : customClassesForTr(element))
          "
        >
          <td
            *ngFor="let column of columns_responsive"
            [class]="'wa-table-simple__cell ' + getClasses(column.extraClass)"
            [ngClass]="{
              'visibility--hide-mobile': element.hideMobile === true
            }"
          >
            <div class="wa-table-simple__cell__item">
              <ng-container
                [ngTemplateOutlet]="column.template"
                [ngTemplateOutletContext]="{
                  $implicit: assignIndex(i, element)
                }"
              >
              </ng-container>
            </div>
          </td>
        </tr>
        <tr
        [routerLink]="getRouteForRow != undefined ? [getRouteForRow(element)?.route] : undefined"
        [queryParams]="getRouteForRow != undefined ? getRouteForRow(element)?.params : undefined"
        [queryParamsHandling]="getRouteForRow != undefined ? 'merge' : 'merge'"
          *ngFor="let row of rows"
          class="wa-table__row wa-table__row--simple"
        >
          <ng-container
            [@slideInOut]="animationDetailsState"
            [ngTemplateOutlet]="row.template"
            [ngTemplateOutletContext]="{ $implicit: assignIndex(i, element) }"
          >
          </ng-container>
        </tr>
      </tbody>
    </ng-container>

    <ng-template #noresults>
      <tbody *ngIf="data && data.length != undefined; else errorMessage" class="wa-table__row-group">
        <tr
        [routerLink]="getRouteForRow != undefined ? [getRouteForRow(element)?.route] : undefined"
        [queryParams]="getRouteForRow != undefined ? getRouteForRow(element)?.params : undefined"
        [queryParamsHandling]="getRouteForRow != undefined ? 'merge' : 'merge'"
          *ngIf="
            showNoResultsMessageCondition === false ||
            showNoResultsMessageCondition == null
          "
          class="status-message status-message--info"
        >
        <td  [attr.colspan]="headers.length">
          {{ showNoResultsMessage }}
        </td>
        </tr>
      </tbody>
    </ng-template>
    <ng-template #errorMessage>
      <tbody class="wa-table__row-group">
        <tr
        [routerLink]="getRouteForRow != undefined ? [getRouteForRow(element)?.route] : undefined"
        [queryParams]="getRouteForRow != undefined ? getRouteForRow(element)?.params : undefined"
        [queryParamsHandling]="getRouteForRow != undefined ? 'merge' : 'merge'"
          class="status-message status-message--info"
        >
        <td         [attr.colspan]="headers.length"
        >
          {{ showErrorMessage }}
        </td>
        </tr>
      </tbody>
    </ng-template>
  </table>
  <div
    *ngIf="showNoResultsMessageCondition === true"
    class="not-found-research uppercase"
  >
    <p>{{ showNoResultsMessage }}</p>
  </div>

</ng-container>
</ng-template>
<app-load-more-button
  [loading]="isDataLoading"
  [areMoreData]="areMoreData"
  (loadMore)="loadMoreInner()"
></app-load-more-button>
<hr class="spacer" />
